import React from 'react';
import WaitingRoomPlayer from './WaitingRoomPlayer';
import { WaitingRoomPlayersInterface } from './WaitingRoomPlayersInterface';

function WaitingRoomOnePlayer({players, isHost}: WaitingRoomPlayersInterface) {

    return (
        <div className="playersWrapper">
            {isHost && players.length === 1 && <div className="waitingRoomOnePlayerInfoWrapper">
                <div className="waitingRoomOnePlayerInfo">Hi there! Share this code with your friends & start playing!</div>
            </div>}
            <div className="onePlayerPlayerWrapper">
                <WaitingRoomPlayer name={players[0].name} image={players[0].image}/>
            </div>
        </div>
    );
};

export default WaitingRoomOnePlayer;